import { useState, useEffect } from 'react';
import "./MediaManager.css";
import Modal from "../shared/Modal";
import { MediaUploader } from './MediaUploader';
import { Asset } from 'effno-core';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/features/appData';
import { apiDeleteAsset, apiGetAsset, apiGetAssetsForWorkspace } from '../../services/AssetService';
import { MediaGallery } from './MediaGallery';
import toast from 'react-hot-toast';
import { toastFail } from '../../config';

const MANAGER_TABS = {
    UPLOAD: "UPLOAD",
    IMAGE: "IMAGE",
    MY_MEDIA: "MY_MEDIA"
}

type MediaManagerProps = {
    isOpen: boolean;
    noSelect?: boolean;
    onClose: () => void;
    onSelectedAsset: (asset: Asset) => void;
}

export const MediaManager = ({isOpen, noSelect = false, onClose, onSelectedAsset} : MediaManagerProps) => {
    
    const storeUser = useSelector(selectUser);
    
    const [tab, setTab] = useState<string>(MANAGER_TABS.UPLOAD);
    const [assets, setAssets] = useState<Asset[] | undefined>(undefined);

    useEffect(() => {
        if (storeUser && !assets) {
            // fetch assets
            (async () => {
                if (storeUser?.currentWorkspaceId) {
                    const theAssets = await apiGetAssetsForWorkspace(storeUser.currentWorkspaceId);

                    if (theAssets) {
                        setAssets(theAssets.sort((a, b) => {
                                return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
                        }));
                    }
                }
            })();
        }
    }, [storeUser]);

    const handleNewAsset = async (asset: Asset) => {
        if (noSelect) {
            setAssets(!assets ? [asset] : [asset, ...assets]);
            setTab(MANAGER_TABS.MY_MEDIA);
            return;
        }

        setAssets(!assets ? [asset] : [...assets, asset]);
        onSelectedAsset(asset);
    }

    const handleSelectedAsset = async (asset: Asset) => {
        onSelectedAsset(asset);
    }

    const handleDeleteAsset = async (asset: Asset) => {
        const result = await apiDeleteAsset(asset.id);

        if (!result) {
            toast("Image deletion failed", toastFail);
            return;
        }

      
        toast("Deleted image", toastFail);
        setAssets(assets?.filter(a => a.id !== asset.id));
    }


    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="media-manager">
                <div className="modal-title">
                    Media Manager
                </div>

                <div className="media-manager-options">
                    <div 
                        className={tab === MANAGER_TABS.UPLOAD ? 
                        "media-manager-option-selected" : "media-manager-option"}
                        onClick={() => setTab(MANAGER_TABS.UPLOAD)}

                    >
                        Upload
                    </div>
                    {/* do unsplash ap later */}
                    {/* <div className={tab === MANAGER_TABS.IMAGE ? 
                        "media-manager-option-selected" : "media-manager-option"}
                        onClick={() => setTab(MANAGER_TABS.IMAGE)}
                    >
                        Image
                    </div> */}
                    <div className={tab === MANAGER_TABS.MY_MEDIA ? 
                        "media-manager-option-selected" : "media-manager-option"}
                        onClick={() => setTab(MANAGER_TABS.MY_MEDIA)}
                    >
                        My Media
                    </div>
                </div>

                {tab === MANAGER_TABS.UPLOAD &&
                    <MediaUploader 
                        onSelectedAsset={handleNewAsset}
                    />
                }

                {tab === MANAGER_TABS.IMAGE &&
                    <div className="media-manager-content">
                        Image content
                    </div>
                }

                {tab === MANAGER_TABS.MY_MEDIA &&
                    <MediaGallery 
                        assets={assets}
                        noSelect={noSelect}
                        onSelectedAsset={handleSelectedAsset}
                        onDeleteAsset={handleDeleteAsset}
                    />
                }
            
            </div>
        </Modal>
    )
}
